import {Base} from "@/api/Base"

export class MpfSettingAdd extends Base {
    path = "mpfSetting/add"
}